import { css } from 'lit';

export default css`

  :host {
    display: block;
  }

  .form-control--inline-radio ::slotted(nile-radio) {
    display: inline-block;
    margin-right: 1.3rem !important;
  }

  .form-control {
    border: none;
    padding: 0;
    margin: 0;
  }

  .form-control__label {
    padding: 0;
  }

  .radio-group--required .radio-group__label::after {
    content: '*';
    margin-inline-start: -2px;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
